import React from "react";
import { NavigationBar, IENotSupportedSplash } from "components";
import { isIE } from "react-device-detect";
import { createGlobalStyle } from "styled-components";
import "../../fonts/font.css";

const GlobalStyles = createGlobalStyle`
  :root {
    --abbvie-red: #B35865;
    --abbvie-green: #03932C;
    --abbvie-bright-green: #11B75F;
    --abbvie-dark-green: #0D703E;
    --abbvie-beige: #e7f1ed;
    --abbvie-dark: #313131;
    --abbvie-blue: #1A1A51;
  }
  * {
      margin:0;
      padding:0;
      box-sizing:border-box;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
  }
  body{
    background: white;
    overflow-x:hidden;
    background-color: white;
    font-family: 'Raleway', sans-serif;
    font-size: 16px;
    overflow-x:hidden;
    min-height:100vh;
    box-sizing: border-box;
  }
  h1,h2,h3,h4,h5,h6{
    margin-block-start:0;
    margin-block-end:0;
    font-family: 'Lato', sans-serif;
  }
  button{
    border:none;
    outline:none;
    :focus, :hover{
        outline:none;
        border:none;
    }
  }
  a {
    text-decoration:none;
  }
  .scroll-lock {
    overflow: hidden;
  }
`;

const Layout = ({ children }) => {
  return !isIE ? (
    <>
      <GlobalStyles />
      <NavigationBar />
      {children}
      {/* <Footer /> */}
    </>
  ) : (
    <IENotSupportedSplash />
  );
};

export default Layout;
